import { Component } from '@theme/component';
import { compareStore, CompareUpdateEvent } from '@theme/compare';

/**
 * A toggle button that adds/removes its product from the compare list.
 * Multiple instances of the same product (e.g. one on a collection card, one
 * on the product page) stay in sync via CompareUpdateEvent.
 *
 * @extends {Component}
 */
export class CompareButtonElement extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#syncState();
    document.addEventListener(CompareUpdateEvent.eventName, this.#onUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CompareUpdateEvent.eventName, this.#onUpdate);
  }

  #onUpdate = () => this.#syncState();

  get #item() {
    return {
      id: this.dataset.productId ?? '',
      handle: this.dataset.productHandle ?? '',
      title: this.dataset.productTitle ?? '',
      image: this.dataset.productImage ?? '',
      url: this.dataset.productUrl ?? '',
      type: this.dataset.productType ?? '',
    };
  }

  /** @param {Event} [event] */
  toggle(event) {
    event?.preventDefault();
    compareStore.toggle(this.#item);
  }

  #syncState() {
    const active = compareStore.has(this.dataset.productId ?? '');
    this.classList.toggle('compare-button--active', active);

    const button = this.querySelector('.compare-button__toggle');
    button?.setAttribute('aria-pressed', String(active));
  }
}

if (!customElements.get('compare-button')) {
  customElements.define('compare-button', CompareButtonElement);
}
